import { Component } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixTextComponent } from "../../prefix-text.component";
import { TemplateTextComponent } from "../../templates/template-text/template-text.component";
import { MaxLength } from "../../types/MaxLength";

@Component({
  selector: "app-prefix-nvl",
  imports: [TemplateTextComponent],
  templateUrl: "./prefix-nvl.component.html",
  styleUrl: "./prefix-nvl.component.less",
})
export class PrefixNvlComponent extends PrefixTextComponent {
  public maxlength: MaxLength;

  public constructor() {
    super();
    this.maxlength = 5;
    this.required = true;
    this.characters = ALLOWED_CHARACTERS["nvl"];
  }
}
